import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import header from "../assets/header.svg";
import arrow from "../assets/arrow_petrol.svg";
import logo from "../assets/logo.svg";
import Nav from "../components/Nav";
import Circles from "../components/Circles";
import Button from "../components/Button";
import finaltext from "../assets/finalpatorget.svg";
import challengetext from "../assets/Quizmaster.svg";
import competetext from "../assets/tavlaom.svg";
import { useModal } from "./../providers/ModalContext";

function Start() {
  const [countdown, setCountdown] = useState(0);
  const [textImg, setTextImg] = useState(competetext);
  const { openModal } = useModal();
  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        const current = prev % 3;
        //setTextImg(current ?  finaltext:competetext);
        if (current === 0) {
          setTextImg(finaltext);
        } else if (current === 1) {
          setTextImg(challengetext);
        } else {  
          setTextImg(competetext);
        }
        return prev + 1;
      });
    }, 4000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <section className="bg-petrol-500">
      <Nav />
      <div className="container">
        <img src={header} alt="header" className="w-[75%] sm:w-[80%]" />
        {/*<div className="aspect-square animate-textanimation w-32 sm:w-56 relative bg-primary rounded-full sm:my-14 my-10 flex items-center justify-center">
          <img src={textImg} className="w-3/5 rotate-[-12deg]" />
  </div>*/}
        <div className="flex w-full flex-col items-center gap-[20px] content-center">
          <div style={{marginTop: 200}}><h1>Frölunda QUIZ är slut för i år. Tack till alla som var med och tävlade!</h1></div>
         {/* <Link to="/quiz">
            <Button text="Börja spela" icon={arrow} buttonClass="primary" />
          </Link>
          <Link to="/topplistan">
            <Button text="Topplistan" buttonClass="secondary" />
  </Link>
          <a className="underline cursor-pointer py-5" onClick={() => openModal('Rules')}>
              Tävlingsregler
            </a>*/}
        </div>
      </div>
      <div className="flex justify-center">
        <img src={logo} alt="logo" className="mt-auto" />
      </div>
      <Circles color="bg-syren-300" />
    </section>
  );
}

export default Start;
